export const calculatePayGrade = (qualification, experience, englishLevel, competencyCount) => {
  // Calculate competency score based on count
  let competencyScore = 0;
  if (competencyCount >= 7) competencyScore = 4;
  else if (competencyCount >= 5) competencyScore = 3;
  else if (competencyCount >= 3) competencyScore = 2;
  else if (competencyCount >= 1) competencyScore = 1;

  // Calculate total score
  const totalScore = parseInt(qualification) + parseInt(experience) + parseInt(englishLevel) + competencyScore;

  // Determine pay rate
  let payRate = 'B';
  if (totalScore >= 14) {
    payRate = 'D';
  } else if (totalScore >= 9) {
    payRate = 'C';
  }

  return { totalScore, payRate };
};
